import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index';
import Login from '../views/Login.vue';
import CustomerDetailsAdmins from '../components/CustomerDetails/Admins.vue';
import CustomerDetailsUsers from '../components/CustomerDetails/Users.vue';
import CustomerDetailsLicenses from '../components/CustomerDetails/Licenses.vue';
import CustomerDetailsSettings from '../components/CustomerDetails/Settings.vue';
import CustomerDetailsIntegration from '../components/CustomerDetails/Integration.vue';
import CustomerDetailsEndCustomer from '../components/CustomerDetails/EndCustomer.vue';
import CustomerDetailsModuleConfig from '../components/CustomerDetails/ModuleConfig.vue';
import Apps from '../components/Apps.vue';
import SuperUsers from '../components/SuperUsers.vue';
import ServiceIntegrationUsers from '../components/ServiceIntegrationUsers.vue';
import FindUser from '../components/FindUser.vue';
import Customers from '../components/Customers.vue';
import AppDetails from '../components/AppDetails.vue';
import Versions from '../components/Versions.vue';
import VersionDetails from '../components/VersionDetails.vue';
import AppsFeatureIntro from '../components/AppsFeatureIntro.vue';
import AppsFeatureIntroDetails from '../components/AppsFeatureIntroDetails.vue';
import AppUsage from '../components/AppUsage.vue';
import { handleChunkLoadError } from '../services/versionChecker';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next('/customers');
      }
    },
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/superusers',
    name: 'superusers',
    component: SuperUsers,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/serviceintegrationusers',
    name: 'serviceintegrationusers',
    component: ServiceIntegrationUsers,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/find-user',
    name: 'finduser',
    component: FindUser,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/apps',
    name: 'apps',
    component: Apps,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/apps/:id',
    name: 'appdetails',
    component: AppDetails,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/apps/${id}`);
      } else {
        next();
      }
    },
  },
  {
    path: '/versions',
    name: 'versions',
    component: Versions,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/versions/:id',
    name: 'versiondetails',
    component: VersionDetails,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        next(`/versions/${to.params.id}`);
      } else {
        next();
      }
    },
  },
  {
    path: '/feature-intro',
    name: 'featureintro',
    component: AppsFeatureIntro,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/feature-intro/:id',
    name: 'featureintrodetails',
    component: AppsFeatureIntroDetails,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = (store.getters['auth/customerId'] !== to.params.id) ? store.getters['auth/customerId'] : to.params.id;
        next(`/apps/${id}`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails',
    name: 'customerdetailsmain',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      const id = ((store.getters['auth/customerId'] !== to.params.id)) ? store.getters['auth/customerId'] : to.params.id;
      next(`/customerdetails/${id}/licenses`);
    },
  },
  {
    path: '/customerdetails/:id',
    name: 'customerdetails',
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      const id = ((store.getters['auth/customerId'] !== to.params.id) && !store.getters['auth/isSuperuser']) ? store.getters['auth/customerId'] : to.params.id;
      next(`/customerdetails/${id}/settings`);
    },
  },
  {
    path: '/customerdetails/:id/admins',
    name: 'customerdetailsadmins',
    component: CustomerDetailsAdmins,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser'] && store.getters['auth/customerId'] !== to.params.id) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/admins`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails/:id/integration',
    name: 'customerdetailsintegration',
    component: CustomerDetailsIntegration,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser'] && store.getters['auth/customerId'] !== to.params.id) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/integrations`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails/:id/endcustomer',
    name: 'customerdetailsendcustomer',
    component: CustomerDetailsEndCustomer,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser'] && store.getters['auth/customerId'] !== to.params.id) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/endcustomer`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails/:id/users',
    name: 'customerdetailsusers',
    component: CustomerDetailsUsers,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser'] && store.getters['auth/customerId'] !== to.params.id) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/users`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails/:id/licenses',
    name: 'customerdetailslicenses',
    component: CustomerDetailsLicenses,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser'] && store.getters['auth/customerId'] !== to.params.id) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails/:id/settings',
    name: 'customerdetailssettings',
    component: CustomerDetailsSettings,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser'] && store.getters['auth/customerId'] !== to.params.id) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/customerdetails/:id/module-config/:appCode/:moduleName',
    name: 'customerdetailsmoduleconfig',
    component: CustomerDetailsModuleConfig,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const { permissions } = store.state.auth;
      const hasAccess = permissions.includes('ROLE_SUPER_ADMIN') || permissions.includes('ROLE_ADMIN');
      if (!hasAccess) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/signin-history',
    name: 'signinhistory',
    component: AppUsage,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isSuperuser']) {
        const id = store.getters['auth/customerId'];
        next(`/customerdetails/${id}/licenses`);
      } else {
        next();
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/isLoggedIn']) {
        // if user is loged can't see a login page
        next('/');
      } else {
        next();
      }
    },
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // catch page if required authorization
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn']) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

router.onError((error) => {
  // Check for chunk loading errors, which can happen after a new deployment.
  const isChunkLoadError = /Loading( CSS)? chunk .* failed/i.test(error.message)
    || /Failed to fetch dynamically imported module/i.test(error.message);

  if (isChunkLoadError) {
    // This is a strong indicator of a new version deployment.
    // Trigger the update notification via the versionChecker service.
    handleChunkLoadError();
  }
});

export default router;
